<template>
  <list-thumb-view getters='staff' />
</template>

<script>
export default {
  components: { ListThumbView: () => { return import('./../users/ListThumbView') } }
}
</script>
